import { css } from 'styled-components';

export const media: { [index: string]: number } = {
  largeDesktop: 1280,
  desktop: 992,
  tablet: 768,
  phone: 576,
};

export const mediaMinWidth = (margin: number, columns?: number): any => {
  return css`
    width: ${320 - margin}px;
    @media (min-width: ${media.phone}px) {
      width: ${media.phone - margin}px;
    }
    @media (min-width: ${media.tablet}px) {
      width: ${media.tablet - margin}px;
    }
    @media (min-width: ${media.desktop}px) {
      width: ${media.desktop / (columns || 1) - margin}px;
    }
    @media (min-width: ${media.largeDesktop}px) {
      width: ${media.largeDesktop / (columns || 1) - margin}px;
    }
  `;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/sharedStyle/mediaQueries.ts